<template>
<v-dialog v-model="active" v-bind="dialogProps">
  <slot v-bind="{cancel: cancel, submit: submit}"></slot>
</v-dialog>
</template>

<script>
export default {
  name: "PickerDialog",
  props: {
    dialogProps: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      active: false,
      resolve: null,
    }
  },
  methods: {
    pop() {
      this.active = true
      return new Promise((resolve, reject) => {
        this.resolve = resolve
      })
    },
    cancel() {
      this.active = false
    },
    submit(value) {
      const resolve = this.resolve
      this.active = false
      this.resolve = null
      resolve(value)
    },
  },
}
</script>
